import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
import { faqs } from '../data/offer';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-espresso px-5 py-14" data-id="element-66" data-mp="1ge0kd14j9kjx">
      <SectionHeading dark eyebrow="Hai dubbi?" title="Domande" accent="frequenti" data-id="element-67" data-mp="2e0g1g1t1sg6y" />
      <Reveal className="mt-9" data-id="element-68" data-mp="2dy3iblbjzzsb">
        <ul className="space-y-2.5" data-id="element-69" data-mp="290tircuga7qr">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={faq.question} className={`rounded-2xl border transition-colors duration-200 ${isOpen ? 'border-wood/50 bg-espresso-2' : 'border-espresso-line bg-espresso-2/60'}`} data-id="element-70" data-mp="1z3fgqi99xlhz" data-mpi={i}>
                <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-3 rounded-2xl px-4 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wood" data-id="element-71" data-mp="nq4otzqp9yoq">
                  <span className="text-[15px] font-semibold text-ivory" data-id="element-72" data-mp="kkxtp4o6cr0o">{faq.question}</span>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-wood text-espresso' : 'bg-espresso-3 text-ivory'}`} data-id="element-73" data-mp="6pdbyck6meuu">
                    <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-74" data-mp="3jxyi5e1i1mqu" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-75" data-mp="3o039g64h67ab">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-76" data-mp="1ugup02zxentq">
                      <p className="px-4 pb-4 pr-12 text-[14px] leading-relaxed text-sand" data-id="element-77" data-mp="2dfozgzscx243">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </Reveal>
    </section>;
}